import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const Information = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-6.535 3.907a.872.872 0 0 1-.182.31c-.474.492-1.057.783-1.749.783-.328 0-.637 0-.965-.055-.529-.073-1.202-.728-1.111-1.42l.218-1.421.219-1.239v-.002l.218-1.236c0-.028.005-.055.01-.082a.496.496 0 0 0 .009-.082c0-.346-.11-.474-.456-.51a3.647 3.647 0 0 1-.437-.073c-.164-.055-.255-.2-.237-.328.018-.146.11-.237.292-.273.09-.018.2-.018.31-.018h2.513c.31 0 .492.145.492.455 0 .255-.037.51-.091.765-.082.473-.169.943-.255 1.412-.087.469-.173.938-.255 1.411-.018.103-.039.207-.059.31-.04.206-.08.413-.105.62-.018.145 0 .309.036.454.055.2.2.31.401.292.164-.018.328-.073.492-.146.053-.023.103-.052.153-.08.07-.041.137-.08.211-.102.219-.073.383.055.328.255ZM13.9 8.33a1.322 1.322 0 0 0-2.64-.019c0 .747.6 1.348 1.329 1.348.71 0 1.311-.6 1.311-1.33Z"
    />
  </Icon>
);

export default Information;
